import { SxProp, View } from 'dripsy';
import React from 'react';
import { H6, TextAmount, TextCaption } from '@/design-system/components/typography';

enum StyleName {
  groupContainer,
  itemContainer,
  itemContainerFirst,
  leftContainer,
  rightContainer
}

interface BaseText {
  label: string;
  data: string;
  success?: boolean;
  error?: boolean;
  info?: boolean;
  warning?: boolean;
  right?: boolean;
}

interface AmountText extends BaseText {
  asset?: string;
  decimals?: number;
}

export interface UniTextGroupProps {
  data: Array<Array<BaseText | AmountText>>;
}

export const UniTextGroup: React.FC<UniTextGroupProps> = (props) => {
  const { data } = props;

  return (
    <View sx={styles[StyleName.groupContainer]}>
      {data.map((row, index) => (
        <TextRow key={`text-${index}`} row={row} index={index} />
      ))}
    </View>
  );
};

const TextRow = (params: { row: Array<AmountText>; index: number }) => {
  const { row, index } = params;
  const leftData = row[0];
  const rightData = row[1];

  const firstStyle = {
    ...styles[StyleName.itemContainer],
    ...styles[StyleName.itemContainerFirst]
  };

  return (
    <View sx={index === 0 ? firstStyle : styles[StyleName.itemContainer]}>
      <View sx={styles[StyleName.leftContainer]}>
        <TextContainer {...leftData} />
      </View>
      <View sx={styles[StyleName.rightContainer]}>
        <TextContainer {...rightData} right />
      </View>
    </View>
  );
};

const TextContainer = (props: BaseText | AmountText) => {
  const { label, data, success, right } = props;
  if ('asset' in props) {
    const { asset, decimals = 0 } = props;
    return (
      <>
        <TextCaption secondary label sx={{ textAlign: right ? 'right' : 'left' }}>
          {label}
        </TextCaption>
        <TextAmount size="H6" weight="bold" currency={asset} decimals={decimals} success={success}>
          {data}
        </TextAmount>
      </>
    );
  }

  return (
    <>
      <TextCaption secondary label sx={{ textAlign: right ? 'right' : 'left' }}>
        {label}
      </TextCaption>
      <H6 bold success={success}>
        {data}
      </H6>
    </>
  );
};

const styles: Record<StyleName, SxProp> = {
  [StyleName.groupContainer]: {
    marginY: '$5'
  },
  [StyleName.itemContainer]: {
    marginTop: '$5',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  [StyleName.itemContainerFirst]: {
    marginTop: '$0'
  },
  [StyleName.leftContainer]: {},
  [StyleName.rightContainer]: {
    alignItems: 'flex-end'
  }
};
